import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useConfirmGuestInfoMutation, useGetGuestDetailsInfoMutation } from '../../../../store/reservations/reservationsApi';
import { LoadingMessages } from '../../../../utils/constants/guest-messages';
import { IToast } from '../../../../interfaces/components/IToast';
import Button from '../../../../shared/button';
import Modal from '../../../../shared/modal';
import Toast from '../../../../shared/toast';


interface IGuestInfoModal {
    openModal: boolean;
    data: any;
    reservationId?: string;
    handleCloseModal: () => void;
}

const GuestInfoModal = ({
    openModal,
    data,
    reservationId,
    handleCloseModal,
}: IGuestInfoModal) => {
    const [allData, setAllData] = useState<any>(data?.guests);
    const [dataName, setDataName] = useState<any>(data?.name);
    const [dateGuest, setDateGuest] = useState<any>(data?.updatedAt || data?.createdAt);
    const [showToast, setShowToast] = useState<IToast | null>();
    const [loadingText, setLoadingText] = useState(LoadingMessages[0]);
    const [getGuestDetailsInfo, { isLoading }] = useGetGuestDetailsInfoMutation();
    const [confirmGuestInfo, { isLoading: isLoadingGuestInfo }] = useConfirmGuestInfoMutation();

    const escapeHtmlString = (htmlString: any) => {
        return htmlString
            .replace(/"/g, '\\"')
            .replace(/\n/g, '\\n')
            .replace(/\r/g, '\\r');
    };

    useEffect(() => {
        if (!isLoading) {
            setLoadingText(LoadingMessages[0]);
            return;
        }

        let index = 0;
        const interval = setInterval(() => {
            index = (index + 1) % LoadingMessages.length;
            setLoadingText(LoadingMessages[index]);
        }, 5000);

        return () => clearInterval(interval);
    }, [isLoading]);

    const onFormatHtml = (text: string) => {
        let htmlText: any
        try {
            htmlText = escapeHtmlString(text);
            htmlText = JSON.parse(`"${htmlText}"`);
        } catch (error) {
            htmlText = text
        }
        // const textFormat = htmlText?.replace(/\n/g, '');
        let parser = new DOMParser();
        let doc = parser.parseFromString(htmlText, "text/html");

        let headers = doc.querySelectorAll("h2");

        headers.forEach((header) => {
            if (header.textContent?.trim().toLowerCase() === "references") {
                let nextElement = header.nextElementSibling;
                if (nextElement && nextElement.tagName.toLowerCase() === "ul") {
                    let listItems = nextElement.querySelectorAll("li");
                    listItems.forEach((li) => {
                        let text = li.textContent?.trim() || "";
                        let urlMatch = text.match(/https?:\/\/[^\s]+/g); // Extract URLs
                        if (urlMatch) {
                            li.innerHTML = urlMatch.map(url =>
                                `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
                            ).join(", ");
                        }
                    });
                }
            }
        });

        return doc.body.innerHTML.replace(/\n/g, '');
    }

    const onCloseModal = () => {
        handleCloseModal();
    }

    const onClickConfirmGuest = async (id: string) => {
        if (reservationId) {
            try {
                const formData = {
                    reservationId: reservationId,
                    guestProfileId: id
                }
                await confirmGuestInfo(formData).unwrap();
                const formatAllData = (allData && allData?.length > 0) && allData?.find((item: any) => item?.id === id)
                setAllData([formatAllData])
            } catch (err) {
                setShowToast({ type: 'error', message: 'Something went wrong!' })
            }
        }
    }

    const onUpdateDataForGuest = async () => {
        try {
            const guestInfoData = {
                name: dataName,
                refresh: true
            }
            const response: any = await getGuestDetailsInfo(guestInfoData).unwrap();
            setAllData(response?.data?.guests)
            setDateGuest(new Date())
        } catch (err) {
            // error here
        }
    }

    const isOlderThanOneMonth = (dateString: string) => {
        const currentDate = new Date();
        const givenDate = new Date(dateString);

        const oneMonthAgo = new Date();
        oneMonthAgo.setMonth(currentDate.getMonth() - 1);

        return givenDate < oneMonthAgo;
    };

    const isOverOneMonth = isOlderThanOneMonth(dateGuest)
    return (
        <Modal
            open={openModal}
            showInRight
            onClose={() => onCloseModal()}
            title='Guest Personal Info'
            contentContainerStyle='min-w-[100vw] md:!min-w-[70vw]'>
            <div className={'p-2 min-w-[95vw] md:min-w-[65vw] min-h-[100%]'}>
                <div className='border-b-2 border-slate-200 pb-2 my-1'>
                    <p className='font-medium text-slate-700'>Guest Info</p>
                </div>
                {(data?.updatedAt || data?.createdAt) &&
                    <div className='mt-3 mb-8 flex flex-row justify-between'>
                        <p className='text-primary-light'>Last Update: {moment(dateGuest)?.format('DD/MM/YYYY')}</p>
                        {isOverOneMonth ?
                            <>
                                {isLoading ?
                                    <p className="px-2 py-2 text-primary-default">{loadingText}</p>
                                    : <Button
                                        label={'Update Data Now'}
                                        className='btn-primary-rounded-less'
                                        onClickButton={onUpdateDataForGuest} />
                                }
                            </>
                            : <div></div>
                        }
                    </div>
                }
                {allData && (Array.isArray(allData) ? allData?.length > 0 : true) ?
                    <>
                        {(Array.isArray(allData) ? allData : [allData])?.map((item: any, index: number) => {
                            return (
                                <div className='rounded-[6px] p-3 mb-6'>
                                    {(Array.isArray(allData) && allData?.length > 1 && reservationId) &&
                                        <div className='flex flex-row justify-end mb-2'>
                                            <Button
                                                label={'Confirm Guest'}
                                                className='btn-primary !rounded-xl mt-2 min-w-[150px]'
                                                onClickButton={() => onClickConfirmGuest(item?.id)}
                                            />
                                        </div>
                                    }
                                    <div
                                        dangerouslySetInnerHTML={{ __html: `${onFormatHtml(item?.htmlContent ? item?.htmlContent : item)}` || "" }}
                                        className="pb-10 px-5 py-3 min-h-72 overflow-auto profile"
                                    ></div>
                                </div>
                            )
                        })}
                    </>
                    : <div className='bg-call-default rounded-[6px] p-3 flex flex-row justify-center items'>
                        <p className='text-primary-light my-10 text-center'>No details found for this Guest</p>
                    </div>
                }
                <div className='flex flex-row justify-center my-5'>
                    <Button
                        label={'Close Modal'}
                        className='btn-primary-rounded-less min-w-[140px]'
                        onClickButton={onCloseModal}
                    />
                </div>
                {showToast?.message &&
                    <Toast
                        type={showToast?.type}
                        text={showToast?.message}
                        onHandleCloseToast={() => setShowToast(null)}
                    />
                }
            </div>
        </Modal >
    )
}
export default GuestInfoModal;
